import React,{ PureComponent}  from 'react';
import Anchor from './../anchor/Anchor';
import './AnchorList.scss';
import immutable from 'immutable';

export default class AnchorList extends PureComponent {
	shouldComponentUpdate(nextProps) {
		return !(nextProps.aData === this.props.aData || immutable.is(nextProps.aData, this.props.aData));
	}
    render() {
	    const props =  this.props;
	    return (
		    <ul className="m-subscribe-anchor-list">
			    {props.aData.map((value, index) =>
				    <Anchor key={value.get("uid")} index={index+1} info={value} search={props.search} />
			    )}
		    </ul>
	    )
    }
}


// WEBPACK FOOTER //
// ./src/views/subscriber-list/anchorList/AnchorList.jsx